import { Component, OnInit, ViewChild } from '@angular/core';
import { UserControlCliService } from '../../../core/services/user-control-cli.service';
import { InventarioSSO } from '../../../core/model/inventario-sso';
import { ToastrService } from 'ngx-toastr';
import { Page } from '../../../core/model/page';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FormControl, Validators } from '@angular/forms';
import { VSaveDireccionAndAsociateModel } from '../../../core/model/v-save-direccion-and-asociate.module';
import { DireccionesService } from '../../../core/services/direcciones.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SsoService } from '../../../core/services/sso.service';

@Component({
  selector: 'app-inventario-sso',
  templateUrl: './inventario-sso.component.html',
  styleUrls: ['./inventario-sso.component.css']
})
export class InventarioSSOComponent implements OnInit {

  loadingGeneral = false;
  loadingFileExcel = false;
  inventarioRecovered: InventarioSSO[] = [];
  page = new Page();
  selectedRow: InventarioSSO = null;

  @ViewChild('tblinv') table: any;
  @ViewChild('tblcentros') tablecenter: any;
  @ViewChild('fileInputMasiva') fileInput;

  frmDireccion = new FormControl('', [Validators.required, Validators.maxLength(100)]);
  frmCodigoPostal = new FormControl('', [Validators.required, Validators.maxLength(20)]);
  frmMunicipio = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  frmProvincia = new FormControl(undefined, [Validators.required]);
  frmTelefono = new FormControl(undefined, [Validators.maxLength(50)]);

  direccionAntigua: string = null;
  fechaCambio: Date = null;

  fileNameInventario: any = null;

  constructor(
    private userControlCliService: UserControlCliService,
    private toastr: ToastrService,
    public authService: AuthenticationService,
    private dirService: DireccionesService,
    private ssoService: SsoService
  ) { }

  ngOnInit() {
    this.page.size = 20;
  }

  changeFileName() {
    this.fileNameInventario = this.fileInput.nativeElement.files[0].name;
  }

  cargaFichero() {
    if (this.fileNameInventario == null) {
      this.toastr.info('Debes seleccionar un fichero a cargar antes de darle a cargar');
      return;
    }
    this.loadingFileExcel = true;
    this.ssoService.loadExcelInventarioUsuarios(this.fileInput.nativeElement.files[0])
      .subscribe(
        (p) => {
          this.loadingFileExcel = false;
          if (!p.isok) {
            this.toastr.warning('No se ha podido cargar el fichero Excel. Mensaje del servidor: ' + p.msg);
          } else {
            this.toastr.success('Se ha cargado correctamente el fichero Excel. Resumen:' +
              '\r\nActualizados: ' + p.updated +
              '\r\nInsertados: ' + p.inserted +
              '\r\nEliminados: ' + p.deleted);
          }
        },
        () => {
          this.toastr.error('Ha ocurrido un error en la llamada al servicio');
        });
  }

  ponerFormularioDireccionSeleccionada() {
    this.frmDireccion.setValue(this.selectedRow.DIRECCION);
    this.frmCodigoPostal.setValue(this.selectedRow.CP);
    this.frmMunicipio.setValue(this.selectedRow.POBLACION);
    this.frmProvincia.setValue(this.selectedRow.PROVINCIA);
    this.frmTelefono.setValue(this.selectedRow.TELEFONO);
    this.direccionAntigua = this.selectedRow.DIR_ANTERIOR;
    this.fechaCambio = this.selectedRow.FECHA_CONTROL;
  }

  onResized($event) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedCenters($event) {
    if (this.tablecenter) {
      setTimeout(() => {
        this.tablecenter.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  getTextRango(rango: number) {
    switch (rango) {
      case 0: return 'Operador';
      case 1: return 'Supervisor';
      case 2: return 'Administrador';
    }
  }

  activateRow($event) {
    if ($event.type == 'click') {
      this.selectedRow = $event.row;
      this.direccionAntigua = null;
      this.fechaCambio = null;
      this.ponerFormularioDireccionSeleccionada();
    }
  }

  resetBloqueoDireccionInventario() {

    if (this.selectedRow == null || this.selectedRow == undefined) {
      return;
    }
    this.loadingGeneral = true;
    this.dirService.resetDireccionCentro(this.selectedRow.Id)
      .subscribe(
        (p) => {
          this.toastr.success('El centro se ha desbloqueado correctamente');
          this.loadingGeneral = false;
        },
        () => {
          this.toastr.error('No se ha podido desbloquear la edicion de direcciones del centro');
          this.loadingGeneral = false;
        });
  }

  guardarDireccionIntroducida() {
    if (!this.frmDireccion.valid ||
      !this.frmCodigoPostal.valid ||
      !this.frmMunicipio.valid ||
      !this.frmProvincia.valid) {
      this.toastr.info('Hay campos que no están correctamente rellenos');
      return;
    }
    this.loadingGeneral = true;
    let toService = new VSaveDireccionAndAsociateModel(
      this.frmDireccion.value,
      this.frmCodigoPostal.value,
      this.frmMunicipio.value,
      this.frmProvincia.value,
      this.frmTelefono.value,
      this.selectedRow.Id
    );
    this.dirService.addDireccionAsociate(toService)
      .subscribe(
        (p: { dirAntigua: string, fecha: Date }) => {
          this.loadingGeneral = false;
          if (p == null || p == undefined) {
            this.toastr.info("Ha ocurrido un problema al guardar la direccion y asociarla a los usuarios que cuelgan del centro");
          } else {
            this.toastr.success("Se ha modificado correctamente la dirección del centro y se ha asociado a todos los usuarios correctamente.");
            this.direccionAntigua = p.dirAntigua;
            this.fechaCambio = p.fecha;
          }
        },
        (err: HttpErrorResponse) => {
          if (err.status == 400) {
            this.toastr.error('Ha ocurrido un error al modificar la direccion del centro ' + err.message);
          }
          this.loadingGeneral = false;
        });
  }

  setPage(centro: string, $event) {
    this.recoverCenters(centro, $event.offset * $event.pageSize, $event.pageSize);
  }

  recoverCenters(centro: string, initial: number = 0, final: number = 10) {
    this.loadingGeneral = true;
    this.selectedRow = null;
    this.direccionAntigua = null;
    this.fechaCambio = null;
    this.userControlCliService.getInventario(initial, final, centro)
      .subscribe(
        (r: any) => {
          this.inventarioRecovered = r.resultado;
          this.page.pageNumber = 0;
          this.page.totalElements = r.contador;
          this.page.size = 10;
        },
        (e: Error) => {
          this.toastr.error('Ha ocurrido un error al recuperar el inventario del SSO. Detalles => ' + e.message);
          this.loadingGeneral = false;
        },
        () => this.loadingGeneral = false
      );
  }

  getProvincia(provincia: number): string {
    switch (provincia) {
      case 1: return 'Alava';
      case 2: return 'Albacete';
      case 3: return 'Alicante';
      case 4: return 'Almería';
      case 5: return 'Avila';
      case 6: return 'Badajoz';
      case 7: return 'Baleares';
      case 8: return 'Barcelona';
      case 9: return 'Burgos';
      case 10: return 'Cáceres';
      case 11: return 'Cádiz';
      case 12: return 'Castellón';
      case 13: return 'Ciudad Real';
      case 14: return 'Córdoba';
      case 15: return 'Coruña';
      case 16: return 'Cuenca';
      case 17: return 'Gerona';
      case 18: return 'Granada';
      case 19: return 'Guadalajara';
      case 20: return 'Guipúzcoa';
      case 21: return 'Huelva';
      case 22: return 'Huesca';
      case 23: return 'Jaén';
      case 24: return 'León';
      case 25: return 'Lérida';
      case 26: return 'La Rioja';
      case 27: return 'Lugo';
      case 28: return 'Madrid';
      case 29: return 'Málaga';
      case 30: return 'Murcia';
      case 31: return 'Navarra';
      case 32: return 'Orense';
      case 33: return 'Asturias';
      case 34: return 'Palencia';
      case 35: return 'Las Palmas';
      case 36: return 'Pontevedra';
      case 37: return 'Salamanca';
      case 38: return 'Santa Cruz de Tenerife';
      case 39: return 'Cantabria';
      case 40: return 'Segovia';
      case 41: return 'Sevilla';
      case 42: return 'Soria';
      case 43: return 'Tarragona';
      case 44: return 'Teruel';
      case 45: return 'Toledo';
      case 46: return 'Valencia';
      case 47: return 'Valladolid';
      case 48: return 'Vizcaya';
      case 49: return 'Zamora';
      case 50: return 'Zaragoza';
      case 51: return 'Ceuta';
      case 52: return 'Melilla';
    }
  }

}
